import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'BV Group has transformed the culinary landscape of Thailand with their authentic Indian restaurants. A must-visit for food enthusiasts.',
  name: 'Sarah Johnson',
  title: 'Food Critic, Bangkok Post'
}, {
  quote: 'The attention to detail in every BV Group restaurant is remarkable. From the decor to the food presentation, everything is perfect.',
  name: 'Michael Chen',
  title: 'Travel Blogger'
}, {
  quote: 'As someone who grew up with authentic Indian cuisine, I can confidently say that BV Group offers the most genuine Indian flavors in Thailand.',
  name: 'Priya Sharma',
  title: 'Culinary Expert'
}];
export function Testimonials() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-323">
      <div className="max-w-7xl mx-auto" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-325">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-326">
            Testimonials
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-327">
            What People Say
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-328" />
          <p className="text-[#86868b] text-[18px] max-w-2xl mx-auto font-light" data-id="element-329">
            Trusted by food critics, travelers, and culinary enthusiasts across
            Thailand
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-330">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#f2f2f4] p-10 relative border border-[#ebebed]" data-id="element-331">
              <span className="absolute top-6 left-8 text-[80px] leading-none text-[#c9a961]/20 font-serif" data-id="element-332">
                "
              </span>
              <p className="text-[#1d1d1f] text-[18px] font-light leading-relaxed mb-8 relative z-10 pt-6 italic" data-id="element-333">
                {testimonial.quote}
              </p>
              <div className="border-t border-[#c9a961]/20 pt-6" data-id="element-334">
                <p className="font-display text-[#1d1d1f] font-medium text-[18px]" data-id="element-335">
                  {testimonial.name}
                </p>
                <p className="text-[#c9a961] text-[13px] uppercase tracking-wide mt-1" data-id="element-336">
                  {testimonial.title}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}